"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartCoin = void 0;
const coin_1 = require("./util/serializer/types/coin");
const coin_spend_1 = require("./util/serializer/types/coin_spend");
const util_1 = require("./util");
const bignumber_1 = require("@ethersproject/bignumber");
class SmartCoin {
    constructor({ parentCoinInfo = null, puzzleHash = null, amount = null, coin = null, puzzle = null, solution = null, } = {}) {
        this.parentCoinInfo = null;
        this.puzzleHash = null;
        this.amount = null;
        this.puzzle = null;
        this.solution = null;
        if (coin !== null && coin !== undefined) {
            this.parentCoinInfo = util_1.Util.dehexlify(coin.parentCoinInfo);
            this.puzzleHash = util_1.Util.dehexlify(coin.puzzleHash);
            this.amount = bignumber_1.BigNumber.from(coin.amount);
        }
        else {
            this.parentCoinInfo = util_1.Util.dehexlify(parentCoinInfo);
            this.puzzleHash = util_1.Util.dehexlify(puzzleHash);
            this.amount = amount !== null ? bignumber_1.BigNumber.from(amount) : null;
        }
        this.puzzle = puzzle;
        this.solution = solution;
        this.calculatePuzzleHash();
    }
    calculatePuzzleHash() {
        if (this.puzzle === null)
            return;
        this.puzzleHash = util_1.Util.sexp.sha256tree(this.puzzle);
    }
    copyWith({ parentCoinInfo = null, puzzleHash = null, amount = null, coin = null, puzzle = null, solution = null, }) {
        const puzzleSupplied = puzzle !== undefined && puzzle !== null;
        const puzzleHashSupplied = puzzleHash !== undefined && puzzleHash !== null;
        const givePuzzle = puzzleSupplied || (puzzleHashSupplied && this.puzzleHash !== puzzleHash);
        return new SmartCoin({
            parentCoinInfo: parentCoinInfo !== null && parentCoinInfo !== void 0 ? parentCoinInfo : this.parentCoinInfo,
            puzzleHash: puzzleHashSupplied ? puzzleHash : this.puzzleHash,
            amount: amount !== null && amount !== void 0 ? amount : this.amount,
            puzzle: givePuzzle ? puzzle : this.puzzle,
            coin: coin !== null && coin !== void 0 ? coin : null,
            solution: solution !== null && solution !== void 0 ? solution : this.solution,
        });
    }
    withParentCoinInfo(parentCoinInfo) {
        return this.copyWith({
            parentCoinInfo,
        });
    }
    withPuzzleHash(puzzleHash) {
        return this.copyWith({
            puzzleHash,
            puzzle: null
        });
    }
    withAmount(amount) {
        return this.copyWith({
            amount: bignumber_1.BigNumber.from(amount),
        });
    }
    withPuzzle(puzzle) {
        return this.copyWith({
            puzzle,
        });
    }
    withSolution(solution) {
        return this.copyWith({
            solution,
        });
    }
    hasCoinInfo() {
        return this.parentCoinInfo !== null &&
            this.puzzleHash !== null &&
            this.amount !== null;
    }
    toCoin() {
        if (!this.hasCoinInfo()) {
            return null;
        }
        const c = new coin_1.Coin();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        c.parentCoinInfo = this.parentCoinInfo;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        c.puzzleHash = this.puzzleHash;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        c.amount = this.amount;
        return c;
    }
    spend() {
        if (!this.isSpendable()) {
            return null;
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const c = this.toCoin();
        const cs = new coin_spend_1.CoinSpend();
        cs.coin = c;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cs.puzzleReveal = this.puzzle;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cs.solution = this.solution;
        return cs;
    }
    getId() {
        const c = this.toCoin();
        if (c === null) {
            return null;
        }
        return util_1.Util.coin.getId(c);
    }
    getName() {
        return this.getId();
    }
    curry(args) {
        if (this.puzzle === null) {
            return null;
        }
        const c = this.toCoin();
        const newPuzzle = util_1.Util.sexp.curry(this.puzzle, args);
        const sc = new SmartCoin({ coin: c, puzzle: newPuzzle });
        return sc;
    }
    isSpendable() {
        return this.hasCoinInfo() && this.puzzle !== null && this.solution !== null;
    }
}
exports.SmartCoin = SmartCoin;
//# sourceMappingURL=smart_coin.js.map